// Splide init
function mmInitSplide() {
    const id = ".splide-mm-cart";
    const splideElem = document.querySelector(id);

    if (splideElem) {
        new Splide(splideElem, {
			type: "slide",
			arrows: true,
			pagination: false,
			wheel: true,
			gap: 20,
			wheelSleep: 200,
			fixedHeight: 200,
			direction: "ttb",
			height: "100%",
			destroy: true,
			breakpoints: {
				768: {
					destroy: false,
					wheel: false,
					arrows: false,
					pagination: true,
					direction: "ltr",
					// dragMinThreshold: 150,
					// perPage: 1,
					padding: {
						right: '1rem',
						left: "1rem",
					},
          fixedWidth: '80vw',
					fixedHeight: 180,
					gap: 10,
				},
			},
		}).mount();
    }
}

function mmInitSlider_mobile_delivery() {
    const id = ".mm-slider-delivery-mobile";
    const splideElem = document.querySelector(id);

    if (splideElem) {
        new Splide(splideElem, {
            type: "loop",
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 2000,
            height: 30,
            perPage: 1,
            direction: "ttb",
            mediaQuery: "min",
            breakpoints: {
                768: {
                    destroy: true,
                },
            },
        }).mount();
    }
}
document.addEventListener(
    "DOMContentLoaded",
    () => {
        mmInitSplide();
        mmInitSlider_mobile_delivery();
        mmGetDeliveryTaxes();
    },
    { once: true }
);

// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

function mmCartSectionElement() {
    return document.getElementById("shopify-section-mm-cart");
}

function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(lineItemKey) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-key="${lineItemKey}"]`);
}

function mmCartItemQuantityEl(lineItemKey) {
    const itemEl = mmCartItem(lineItemKey);

    return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(lineItemKey) {
    const quantityEl = mmCartItemQuantityEl(lineItemKey);

    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(lineItemKey, newQuantity) {
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(lineItemKey);

        quantityEl.dataset.itemQuantity = newQuantity;
        quantityEl.innerText = newQuantity;
    }
}

function mmCartHTMLFromData(data) {
    const el = document.createElement("DIV");
    // console.log('data.sections["mm-cart"] :', data.sections["mm-cart"]);
    el.innerHTML = data.sections["mm-cart"];
    return el;
}

function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);
    return el.querySelector(".mm-dc-products-container");
}

function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

    return data;
}

function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
    return cartEl.querySelector("[data-cart-total-price]");
}

function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;

    return data;
}

function mmAPIRequest(method, path, body) {
    document.querySelector(".mm-dc-products").classList.add("mm-inactive");
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((data) => {
            if (document.querySelector(".mm-dc-products")) {
                document.querySelector(".mm-dc-products").classList.remove("mm-inactive");
            }
            if (mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner")) { 

              // Afficher le cookie "discount_code"
              const discountCodeCookie = getCookie("discount_code");
              let freeShippingDiscount = false;

              if (discountCodeCookie) {
                const discountCode = document.querySelector("#mmCartProgressBarValue").dataset.discountCode;
                if (discountCode && discountCodeCookie == discountCode ) {
                  freeShippingDiscount = true
                  console.log("Cookie 'discount_code' trouvé :", discountCode);
                }
              }

                const cartProgressId = document.querySelector('#mmCartProgressBarValue');
                const cartProgressValue = cartProgressId.value;
                const freeItemsProgress = mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner");
                const newWidth = ((data.total_price / cartProgressValue) * 100) / 2;

              console.log(freeShippingDiscount)

                if (freeShippingDiscount || newWidth >= 50) {
                    freeItemsProgress.style.width = "100%";
                  console.log('100%')
                } else {
                    freeItemsProgress.style.width = `${newWidth}%`;
                  console.log(newWidth)
                }

                if ( freeShippingDiscount || data.total_price >= cartProgressValue ) {
                    document.querySelector(".mm-dc-free-item-progress-wrapper").classList.add("mm-dc-pb-success");
                } else {
                    document.querySelector(".mm-dc-free-item-progress-wrapper").classList.remove("mm-dc-pb-success");
                }
            }
            var cta = document.querySelector(".mm-dc-cta");
            cta.dataset.totalPrice = data.total_price;
            cta.dataset.totalWeight = data.total_weight;
            mmGetDeliveryTaxes();
            updateCartCount(data.item_count != null ? data.item_count : 0);
            return data;
        })
        .then((data) => {
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

// récupérer le panier
function mmGetCart() {
    mmAPIRequest("GET", "cart.js").then(console.log);
}

// Ouvrir le panier
function mmOpenCart() {
    document.querySelector(".mm-drawer-cart-filter").classList.add("mm-dc-is-open");
    document.querySelector("html").classList.add("stop-scrolling");
}

// Fermer le panier
function mmCloseCart() {
    document.querySelector(".mm-drawer-cart-filter").classList.remove("mm-dc-is-open");
    document.querySelector("html").classList.remove("stop-scrolling");
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
    const newCartEl = document.createElement("DIV");
    newCartEl.innerHTML = data.sections["mm-cart"];
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
    innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;
    const productProgressBarContainer =  document.querySelector('.mm-product-progress-bar-container');
    if (productProgressBarContainer) {
      productProgressBarContainer.innerHTML = newCartEl.querySelector(".mm-cart-progress-bar-container").innerHTML;
    }
    mmInitSplide();
    mmInitSlider_mobile_delivery();
    updateCartCount(newCartEl.querySelector("[data-cart-count]").dataset.cartCount);
    mmGetDeliveryTaxes();
    discountFreeShipping();
    //updateProductForm();
    updateProgressBarPreview();
    updatePricesBasedOnCart();
}

// Ajouter un item au panier
function mmAddProductToCart(productId, { quantity = 1, openCart = true }, checkout = false) {
  console.log('product id', productId);
  let items = [];

  // Gestion du upsell plaque métal
  const plaqueMetalUpsell = document.querySelector(".mm-upsell-plaque-metal");
  if (plaqueMetalUpsell && !plaqueMetalUpsell.classList.contains('mm-clickable')) {
    const upsellId = plaqueMetalUpsell.dataset.plaqueId;
    items.push({
      quantity: 1,
      id: upsellId,
    });
  }

  // Ajout du produit principal
  items.push({
    quantity: quantity,
    id: productId,
  });

  // Ajout des accessoires cochés
  const accessoryCheckboxes = document.querySelectorAll(".mm-product-accessories-container input[type='checkbox']:checked");
  accessoryCheckboxes.forEach((checkbox) => {
    items.push({
      quantity: 1,
      id: checkbox.value,
    });
  });

  // Envoi vers le panier
  mmAPIRequest("POST", "cart/add.js", {
    items: items,
    sections: "mm-cart",
  })
    .then(refreshCartFromData)
    .then((data) => {
      if (openCart) {
        setTimeout(mmOpenCart);
      }
      // Reset du product form button
      const ctaElements = document.querySelectorAll('#product-form .mm-product-cta .mm-product-price-update');
      if (!ctaElements || ctaElements.length === 0) {
        return;
      }      
      ctaElements.forEach(cta => {
        const initialPrice = cta.dataset.price;
        if (!initialPrice || isNaN(initialPrice)) {
          return;
        }
        cta.dataset.value = initialPrice;
        cta.innerHTML = `${(initialPrice / 100).toFixed(2).replace('.', ',')}€`;
      });      
    })
    .catch((error) => {
      mmOpenCart();
      console.log(error);
    });

}

function mmAddCrossSellToCart(btnElem) {
  let card = btnElem.closest('.mm-dc-product-variant-popup');
  const select = card.querySelector('select.mm-upsell-variant-values');
  const variantId = parseInt(select.value);
  mmAddProductToCart(variantId, { quantity: 1, openCart: false });
}

function mmAddCrossSellToCartMobile(btnElem) {
  let card = btnElem.closest('.mm-dc-cs-product');
  const select = card.querySelector('select.mm-upsell-variant-values');
  const variantId = parseInt(select.value);
  mmAddProductToCart(variantId, { quantity: 1, openCart: false });
}

function mmIncreaseProductQuantity(lineItemKey) {
    const quantity = mmGetCartItemQuantity(lineItemKey);
    const newQuantity = quantity + 1;
    mmSetCartItemQuantity(lineItemKey, newQuantity);

    mmDebouncedPushNewQuantity(lineItemKey);
}

function mmDecreaseProductQuantity(lineItemKey) {
    const quantity = mmGetCartItemQuantity(lineItemKey);
    const newQuantity = quantity - 1;
    mmSetCartItemQuantity(lineItemKey, newQuantity);

    mmDebouncedPushNewQuantity(lineItemKey);
}

function mmDestroyProductFromCart(lineItemKey) {
    const newQuantity = 0;
    mmSetCartItemQuantity(lineItemKey, newQuantity);

    mmDebouncedPushNewQuantity(lineItemKey);
}

function mmPushNewQuantity(lineItemKey) {
    const quantity = mmGetCartItemQuantity(lineItemKey);

    mmAPIRequest("POST", "cart/change.js", {
        id: lineItemKey,
        quantity: quantity,
        sections: "mm-cart",
    })
    .then(refreshCartFromData)
}

const mmDebouncedPushNewQuantity = debounce(function (lineItemKey) {
    mmPushNewQuantity(lineItemKey);
}, 300);

// CROSS SELL
function mmOpenVariantPopUp(elem) {
    var variantPopUp = elem.querySelector(".mm-dc-product-variant-popup");
    variantPopUp.style.top = "0";
}
function mmCloseVariantPopUp(elemClass) {
    var elem = document.querySelector(elemClass);
    setTimeout(() => {
        elem.style.top = "100%";
    }, "300");
}


function mmGetDeliveryTaxes() {
    if (document.querySelector(".mm-drawer-cart-filter").dataset.deliveryTaxes == "true") {
        var codePays;
        if (sessionStorage["ipCountryCode"] != null && sessionStorage["ipCountryCode"] != "null" && sessionStorage["ipCountryCode"] != "undefined") {
            codePays = sessionStorage["ipCountryCode"];
        } else if (document.querySelector(".weglot-container .wgcurrent") != null) {
            codePays = document.querySelector(".weglot-container .wgcurrent").dataset.l.toUpperCase();
        } else {
            codePays = document.documentElement.lang.toUpperCase();
        }

        var timeZone = sessionStorage["timezone"];
        if (timeZone == null) {
            timeZone = "EU";
        }
        var cta = document.querySelector(".mm-dc-cta");
        var total_price = cta.dataset.totalPrice;
        var total_weight = cta.dataset.totalWeight;

        var region;
        var weight;
        var key;
        var price;

        // Update le titre de la section
        updatePays(codePays);

        // code pays
        if (codePays == "FR" || codePays == "BE") {
            region = "FR_BE";
        } else if (timeZone.includes("Europe")) {
            region = "UE";
        } else {
            region = "World";
        }

        // Poids
        var cart_emtpy = false;
        if (total_price == 0) {
            cart_emtpy = true;
        } else if (total_weight < 100) {
            weight = "_100";
            key = region + weight;
        } else {
            weight = "_standart";
            if (total_price < 4900) {
                price = "_under_49";
            } else if (region != "World") {
                price = "_more_than_49";
            } else if (total_price < 9900) {
                price = "_between_49_99";
            } else if (total_price >= 9900) {
                price = "_more_than_99";
            }
            key = region + weight + price;
        }
        //console.log(key);
        var item = null;
        item = listDeliveryTaxes.find((item) => {
            if (item.key === key) {
                return item;
            }
        });

        var delivery_container = document.querySelector(".mm-dc-delivery-taxes-container");
        var ul_delivery = document.querySelector(".mm-dc-delivery-taxes-content");
        ul_delivery.innerHTML = "";
        var mobileContainer = document.querySelector("#mm-delivery-mobile-time");

        if (cart_emtpy) {
            delivery_container.style.display = "none";
        } else {
            delivery_container.style.display = "block";
        }
        if (item != null && item.type_denvoi_1 != null && item.type_denvoi_1 != "unset") {
            var li = newDeliveryLine(item.type_denvoi_1, item.prix_1, item.delais_1);
            ul_delivery.appendChild(li);
            if (mobileContainer != null) {
                mobileContainer.innerHTML = item.delais_1;
            }
        }
        if (item != null && item.type_denvoi_2 != null && item.type_denvoi_2 != "unset") {
            var li = newDeliveryLine(item.type_denvoi_2, item.prix_2, item.delais_2);
            ul_delivery.appendChild(li);
        }
        if (item != null && item.type_denvoi_3 != null && item.type_denvoi_3 != "unset") {
            var li = newDeliveryLine(item.type_denvoi_3, item.prix_3, item.delais_3);
            ul_delivery.appendChild(li);
        }
    }
}

function newDeliveryLine(name, price, time) {
    // Création des éléments DOM
    var li = document.createElement("li");
    var nameAndTimeSpan = document.createElement("span");
    var priceSpan = document.createElement("span");
    var div = document.createElement("div");

    // Définition des valeurs des éléments
    nameAndTimeSpan.innerHTML = name + " : " + time;
    if (price == "0.0") {
        priceSpan.innerHTML = mmTextFree();
    } else {
        priceSpan.innerHTML = price.replace(".", ",") + "€";
    }

    // Ajout des éléments au DOM
    div.appendChild(nameAndTimeSpan);
    div.appendChild(priceSpan);
    li.appendChild(div);

    // Retourne l'élément de ligne créé
    return li;
}

// Cart count
function updateCartCount(value) {
    var cartCountValue = document.querySelector(".mm-cart-count-bubble span");
    cartCountValue.innerText = value;
}

// check cookies
function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    return null; // Si le cookie n'est pas trouvé
}

function discountFreeShipping() {
  let freeShippingDiscount = false;
  // Afficher le cookie "discount_code"
  const discountCodeCookie = getCookie("discount_code");
  if (discountCodeCookie) {
    const discountCode = document.querySelector("#mmCartProgressBarValue").dataset.discountCode;
    if (discountCode && discountCodeCookie == discountCode ) {
      freeShippingDiscount = true
      console.log("Cookie 'discount_code' trouvé :", discountCode);
      const freeItemsProgress = mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner");
      freeItemsProgress.style.width = "100%";
      document.querySelector(".mm-dc-free-item-progress-wrapper").classList.add("mm-dc-pb-success");
      document.querySelector(".mm-dc-free-item-progress-wrapper").classList.add("mm-dc-pb-success-discount");
    }
  }

}

discountFreeShipping()

function updateProductForm() {
  const containerSelector = '.mm-product-accessories-container';
  const container = document.querySelector(containerSelector);

  if (!container) return; // Ne fait rien si le conteneur n'existe pas

  const sectionId = container.closest('section').id.replace('shopify-section-', '');
  
  fetch(window.location.pathname + `?sections=${sectionId}`)
    .then((response) => response.json())
    .then((data) => {
      const parser = new DOMParser();
      const sectionHTML = data[sectionId];
      const doc = parser.parseFromString(sectionHTML, 'text/html');
      const newContent = doc.querySelector(containerSelector);

      if (newContent) {
        container.innerHTML = newContent.innerHTML;
      }
    })
    .catch((error) => {
      console.error('Erreur lors du rechargement de la section :', error);
    });
}

function updatePricesBasedOnCart() {
  const accessoryInCart = document.querySelector('data-accessory-in-cart');
  const cards = document.querySelectorAll('.mm-accessory-card');

  console.log('accessoryInCart', accessoryInCart)

  const product_value = parseInt(document.querySelector('#mmDataPriceElem')?.dataset.value || 0);
  const cart_value = parseInt(document.querySelector('.mm-dc-cta')?.dataset.totalPrice || 0);
  const total_predictive_value = product_value + cart_value;

  console.log('total_predictive_value from cazrt script', total_predictive_value)

  if (total_predictive_value >= 3000) {

    cards.forEach(card => {
        const reduced = card.querySelector('[data-reduced]');
        const original = card.querySelector('[data-original]');
        console.log('card', card)

        if (accessoryInCart) {
        // Accessoire déjà dans le panier : afficher prix original
        if (reduced) reduced.style.display = 'none';
        if (original) original.style.display = 'block';
        } else {
        // Pas d’accessoire dans le panier : afficher prix réduit
        if (reduced) reduced.style.display = 'block';
        if (original) original.style.display = 'none';
        }
    });
    }
}

document.addEventListener("DOMContentLoaded", (event) => {
  //updatePricesBasedOnCart();
});


